const ParagraphIcon = /*#__PURE__*/ [
  ["path", { d: "M15 3V21M15 3H10M15 3H21M10 12H7.5C5.01472 12 3 9.98528 3 7.5C3 5.01472 5.01472 3 7.5 3H10M10 12V3M10 12V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export { ParagraphIcon as default };
//# sourceMappingURL=ParagraphIcon.js.map
